<div class="dropup zas-info-directive zbd-info">
    <div class="dropdown-toggle">
        <span
            class="zbd-action-icon icon-i-snippet tracking-action"
            (click)="toggle()"
        ></span>
    </div>
    <div class="dropdown-menu dropdown-menu-ie-fix" #dropdown>
        <div class="close">
            <span
                class="zas-icon icon-close-tag"
                (click)="dropdown.style.display = 'none'"
            ></span>
        </div>
        <div class="headline">Textvorschläge</div>
        <div class="body">
            <ul class="snippet-container">
                <li
                    *ngFor="let snippet of snippets"
                    (click)="onSnippetClick(snippet)"
                >
                    {{ snippet }}
                </li>
            </ul>
            <div class="zas-row">
                <div class="zas-main-col">
                    <button
                        class="btn btn-default"
                        (click)="dropdown.style.display = 'none'"
                    >
                        Schließen
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
